// ./components/chart.jsx
export const COLORS = [
	'children-children-babysitting',
	'health-health-pharmacy',
	'insurance-insurance-accident',
	'office-office-electricity',
	'shopping-shopping-flowers',
];
